var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelInstaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.801,
    y1: 0.134,
    x2: 0.172,
    y2: 0.846,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a0fd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#cd6668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdb602"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IG_22",
    transform: "translate(-24 -152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "instagram-round",
    d: "M11,0A11,11,0,1,1,0,11,11,11,0,0,1,11,0ZM8.427,4.962h5.147a3.5,3.5,0,0,1,3.51,3.464V13.56a3.5,3.5,0,0,1-3.51,3.464H8.427a3.5,3.5,0,0,1-3.51-3.464V8.427A3.5,3.5,0,0,1,8.427,4.962Zm2.54,2.778a3.4,3.4,0,1,1-3.4,3.4A3.4,3.4,0,0,1,10.967,7.74Zm0,1.148a2.25,2.25,0,1,1-2.25,2.25A2.253,2.253,0,0,1,10.967,8.888ZM14.26,7.265a.554.554,0,1,1-.554.554A.553.553,0,0,1,14.26,7.265ZM8.849,5.945h4.3a2.936,2.936,0,0,1,2.936,2.923V13.2a2.936,2.936,0,0,1-2.936,2.923h-4.3A2.936,2.936,0,0,1,5.912,13.2V8.869A2.936,2.936,0,0,1,8.849,5.945Z",
    transform: "translate(24 152)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelInstaIcon);
export default __webpack_public_path__ + "static/media/channel-insta-icon.c8da0d411e40b18bdf20a97c2d94aebf.svg";
export { ForwardRef as ReactComponent };